import React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import LottieView from "lottie-react-native";

type LoaderProps = {
  /**
   * Size of the loader in pixels
   * @default 100
   */
  size?: number;
  /**
   * Additional styles for the container
   */
  style?: ViewStyle;
};

/**
 * Custom Loader Component
 * 
 * A reusable loader using the custom purple dots Lottie animation
 * Replaces the default ActivityIndicator throughout the app
 * 
 * Usage:
 * ```tsx
 * import { Loader } from "@/components/Loader";
 * 
 * // Default size (100px)
 * <Loader />
 * 
 * // Custom size
 * <Loader size={120} />
 * 
 * // With custom styles
 * <Loader size={80} style={{ marginVertical: 20 }} />
 * ```
 * 
 * @param size - Size of the loader in pixels (default: 100)
 * @param style - Additional styles for the container
 */
export const Loader: React.FC<LoaderProps> = ({ size = 100, style }) => {
  return (
    <View style={[styles.container, { width: size, height: size }, style]}>
      <LottieView
        source={require("@/assets/Loader.json")}
        autoPlay
        loop
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
  },
});

